module.exports = __webpack_public_path__ + "static/media/hero.be8fd0cb.jpg";